import {
  AppstoreOutlined,
  NumberOutlined,
  PictureOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const MarketplacePage = lazyRouteComponent(() => import('./pages/marketplace'));
const MarketplaceRedirectPage = lazyRouteComponent(
  () => import('./pages/marketplace-redirect'),
);

const CardDetailsPage = lazyRouteComponent(
  () => import('./pages/card-details'),
);
const AdminArtworksPage = lazyRouteComponent(
  () => import('./pages/admin-artworks'),
);
const AdminCardsPage = lazyRouteComponent(() => import('./pages/admin-cards'));
const AdminRaritiesPage = lazyRouteComponent(
  () => import('./pages/admin-rarities'),
);
const AdminCollectionsPage = lazyRouteComponent(
  () => import('./pages/admin-collections'),
);

const AdminCollectionDetailsPage = lazyRouteComponent(
  () => import('./pages/admin-collection-details'),
);

export const getRoutes = (): Route[] => [
  {
    page: AdminCollectionDetailsPage,
    path: ROUTE_PATHS.ADMIN_COLLECTION_DETAILS,
    title: 'Detalhes da coleção',
    hidden: true,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: AdminCardsPage,
    path: ROUTE_PATHS.ADMIN_CARDS,
    title: 'Pesquisa de cartas',
    icon: SearchOutlined,
    adminSection: 'catalog',
    adminOrder: 10,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: AdminArtworksPage,
    path: ROUTE_PATHS.ADMIN_ARTWORKS,
    title: 'Artes das cartas',
    icon: PictureOutlined,
    adminSection: 'catalog',
    adminOrder: 20,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: AdminRaritiesPage,
    path: ROUTE_PATHS.ADMIN_RARITIES,
    title: 'Raridades',
    icon: NumberOutlined,
    adminSection: 'catalog',
    adminOrder: 30,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: AdminCollectionsPage,
    path: ROUTE_PATHS.ADMIN_COLLECTIONS,
    title: 'Coleções',
    icon: AppstoreOutlined,
    adminSection: 'catalog',
    adminOrder: 40,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
  {
    page: MarketplaceRedirectPage,
    path: ROUTE_PATHS.MARKETPLACE,
    title: 'Catálogo',
    hidden: true,
    public: true,
  },
  {
    page: MarketplacePage,
    path: ROUTE_PATHS.CARDS,
    title: 'Catálogo',
    hidden: true,
    public: true,
  },
  {
    page: CardDetailsPage,
    path: ROUTE_PATHS.CARD_DETAILS,
    title: 'Detalhes da carta',
    hidden: true,
    public: true,
  },
];
